<template>
  <div class="thankyou-container ">
    <div class="w100">
      <wrap-container class="thankyou-inner-container">
        <wrap-container class="cascade w50 first-container">
          <img class="image-gracias" :src="getImage()" alt="gracias" />
          <p class="titulo p32">
            <strong class="name">{{ nombre }}</strong
            >, <span v-html="titulo"></span>
          </p>
          <p v-if="isPF" class="titulo p22">
            {{ graciasData.offerSubtitulo }}
          </p>
        </wrap-container>

        <wrap-container v-if="!isPF" class="cascade w50 second-container">
          <p class="titulo-detalle">Próximos pasos...</p>
          <offer-group label-color="white" item-color="white" :numeric="false">
            <offer-element
              v-for="next in nextSteps"
              :key="next"
              label-light="true"
              :label="next"
            />
          </offer-group>
        </wrap-container>
      </wrap-container>
    </div>
    <help class="help" :showIcon="false" />
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import OfferElement from "@/components/core/OfferElement";
import OfferGroup from "@/components/core/OfferGroup";
import GRACIAS from "@/config/constants/gracias";
import Help from "@/components/core/Help";

export default {
  name: "ThankYou",
  components: { WrapContainer, OfferElement, OfferGroup, Help },
  methods: {
    getImage() {
      return require("@/assets/img/2x/" + this.graciasData.img);
    }
  },
  computed: {
    isPF() {
      return this.$store.getters.getPaso1().esPF === true;
    },
    graciasData() {
      return GRACIAS["ok"];
    },
    titulo() {
      return this.isPF === true
        ? this.graciasData.offerEmprendedor
        : this.graciasData.offer;
    },
    nextSteps() {
      return this.graciasData.nextSteps;
    },
    nombre() {
      return this.$store.getters.getPaso1().razonSocial;
    }
  }
};
</script>

<style scoped>
div.thankyou-container {
  color: white;
  text-align: left;
}

div.thankyou-inner-container img {
  display: block;
  margin-bottom: 36px;
}

.help >>> a {
  color: white;
}

p.header {
  font-size: 26px;
}

p.titulo.p32 {
  line-height: 40px;
  font-size: 30px;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}

.name {
  text-transform: capitalize;
  font-size: 30px;
}
.image-gracias {
  width: 150px;
  height: 150px;
}

@media screen and (min-width: 600px) {
  .thankyou-inner-container {
    display: flex;
  }
  .first-container {
    padding-right: 20px;
  }
  .second-container {
    padding-left: 20px;
    padding-top: 122px; /* Alineación de título "próximos pasos" */
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
  .titulo-detalle {
    margin-top: 0;
  }
}
</style>
